import { ApiService } from './api/api'
import { processParams } from '@/utils/params'
import type { Product } from '@/data/schema/product'

export default class ProductService {
	private apiService
	private launchpadApiService

	constructor() {
		this.apiService = new ApiService()
		this.launchpadApiService = new ApiService(false) // launchpad
	}

	/**
	 * Get all products
	 * @returns Promise
	 */
	getAll(params?: Record<string, string | string[]>): Promise<any> {
		return this.apiService.get(`/products`, { params: processParams(params) })
	}

	/**
	 * Get a product
	 * @param id String
	 * @param params Record<string, string | string[]
	 * @returns Promise
	 */
	get(id: string, params?: Record<string, string | string[]>): Promise<any> {
		return this.apiService.get(`/products/${id}`, { params: processParams(params) })
	}

	create(data: Product, params?: Record<string, string | string[]>): Promise<any> {
		return this.apiService.post(`/products`, data, { params: processParams(params) })
	}

	update(id: string, data: Product, params?: Record<string, string | string[]>): Promise<any> {
		return this.apiService.put(`/products/${id}`, data, { params: processParams(params) })
	}

	addSubGroup(productId: string, data: any): Promise<any> {
		return this.apiService.post(`/products/${productId}/subgroups`, data)
	}

	removeSubGroup(productId: string, subGroupId: number): Promise<any> {
		return this.apiService.delete(`/products/${productId}/subgroups/${subGroupId}`)
	}

	removeSubGroupsByCodes(productId: string, codes: string[]): Promise<any> {
		return this.apiService.delete(`/products/${productId}/subgroups`, { data: { codes } })
	}

	addVideo(productId: string | number, data: { url: string; description: string }): Promise<any> {
		return this.apiService.post(`/products/${productId}/videos`, data)
	}

	removeVideo(productId: string | number, videoId: string | number): Promise<any> {
		return this.apiService.delete(`/products/${productId}/videos/${videoId}`)
	}

	delete(id: string): Promise<any> {
		return this.apiService.delete(`/products/${id}`)
	}
}
